<template>
    <i
        class="fa fa-lg pointer"
        :class="'fa-' + icon"
        @click.prevent="creditInvoiceModalShown = true"
        :title="uLang('app.credit_the_invoice')"
    >
        <portal to="modals" v-if="creditInvoiceModalShown">
            <b-modal
                v-model="creditInvoiceModalShown"
                :hideFooter="true"
                :title="uLang('app.create_entity', { entity: lang('app.credit_invoice') })"
                size="lg"
            >
                <credit-invoice-form
                    :invoiceId="invoiceId"
                    :overrideEndpoint="endpoint"
                    :type="type"
                    @close="creditInvoiceModalShown = false"
                    @creditInvoiceCreated="handleInvoiceCreated"
                />
            </b-modal>
        </portal>
    </i>
</template>

<script>
import { CreditInvoiceForm } from '~/components/forms'

export default {
    name: 'CreateCreditInvoiceButton',

    components: {
        CreditInvoiceForm
    },

    props: {
        icon: {
            type: String,
            required: false,
            default: 'undo',
        },
        invoiceId: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            default: 'sales',
        }
    },

    data() {
        return {
            creditInvoiceModalShown: false,
        }
    },

    computed: {
        endpoint() {
            if (this.type === 'sales') {
                return route('invoices.credit.store', { invoice: this.invoiceId })
            }

            return route('invoices.buy.credit', { invoice: this.invoiceId })
        }
    },

    methods: {
        handleInvoiceCreated() {
            this.creditInvoiceModalShown = false
            Event.$emit('vue-tables.filter::alphabet', query);
        }
    }
}
</script>

<style>

</style>